"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZendeskFlag = getZendeskFlag;
const constants_1 = require("./constants");
const fetch_flags_1 = require("./fetch-flags");
function getZendeskFlag() {
    return (0, fetch_flags_1.getFlags)().get(constants_1.FeatureFlagKey.ZENDESK);
}
//# sourceMappingURL=selectors.js.map